import { render, staticRenderFns } from "./SalesReportsTabKpis.vue?vue&type=template&id=40bd8372&scoped=true"
import script from "./SalesReportsTabKpis.vue?vue&type=script&lang=js"
export * from "./SalesReportsTabKpis.vue?vue&type=script&lang=js"
import style0 from "./SalesReportsTabKpis.vue?vue&type=style&index=0&id=40bd8372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd8372",
  null
  
)

export default component.exports